/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import React from 'react';
import { defineMessages } from 'react-intl';
import { useParams } from 'react-router';
import { CluEntityDetailsWrapper } from 'src/clu/appShell/cluEntityDetailsPage/components/CluEntityDetailsWrapper';
import { Page } from 'src/core/components/Page';
import { useLocalization } from 'src/core/hooks/useLocalization';

const messages = defineMessages({
    pageTitle: {
        id: 'clu.cluEntityDetailsPage.pageTitle',
        defaultMessage: 'Entity components'
    },
    compositionOptions: {
        id: 'clu.cluEntityDetailsPage.compositionOptions',
        defaultMessage: 'Composition options'
    }
});

/**
 * Component displaying the entity capabilities and composition options
 */
export const CluEntityDetailsPage = () => {
    const { localize } = useLocalization();
    const { entityName } = useParams<{ entityName: string }>();

    return (
        <Page size="container-fluid" pageName="BuildSchemaPage" title={localize(messages.pageTitle)}>
            <CluEntityDetailsWrapper entityName={entityName} />
        </Page>
    );
};
